import React from 'react'
import { useTranslation } from 'react-i18next'
import { useReactiveVar } from '@apollo/client'
import { Divider } from '@material-ui/core'
import { calculatorVar } from '../../../apollo/reactive-vars'
import { LocalGridFragment } from '../../../generated/graphql'
import { Section } from '../../common/Section'
import { ReportPurchasedEnergyTable } from '../../system-container/report/ReportPurchasedEnergyTable'
import { ReportDemandsTable } from '../../system-container/report/ReportDemandsTable'
import { Printable } from '../../common/Printable'
import { ReportEnergySystemsSection } from '../../system-container/report/ReportEnergySystemsSection'
import { localGridNetEnergySubCategories } from '../../../provider/result-categories'

type Props = {
  localGrid: LocalGridFragment
}

export function LocalGridReportTab({ localGrid }: Props): React.ReactElement {
  const calculator = useReactiveVar(calculatorVar)
  const { t } = useTranslation()

  const localGridCalculator = calculator?.findLocalGrid(localGrid.id)

  if (!localGridCalculator) {
    return <></>
  }

  const providers = localGridCalculator.getProviders()

  return (
    <Printable>
      <Section title={t('report.purchasedEnergies')}>
        <ReportPurchasedEnergyTable providers={providers} />
      </Section>

      <Divider />

      <ReportEnergySystemsSection providers={providers} />

      <Divider />

      <Section title={t('report.totalEnergyDemands')}>
        {localGridNetEnergySubCategories.map((subCategory) => (
          <ReportDemandsTable
            key={`demands-by-${subCategory.nameKey}-table`}
            demandFlows={localGridCalculator.getPrimaryDemands()}
            subCategory={subCategory}
          />
        ))}
      </Section>
    </Printable>
  )
}
